import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FormEvent, Fragment, useState } from "react";
import {
  Button,
  FormControl,
  InputGroup,
  Modal,
  Spinner,
  Form,
} from "react-bootstrap";
import User, { IUserResource } from "../../models/user";
interface Props {
  user: IUserResource;
  onDeleted?: (user: IUserResource) => void;
}
const DeleteUser: React.FC<Props> = ({ user, onDeleted }) => {
  const [loading, setLoading] = useState(false);
  const [shown, setShown] = useState(false);
  const deleteUser = async () => {
    try {

      setLoading(true);
      await User.Delete(user);
      setLoading(false);
      setShown(false);
      if (onDeleted) {
        onDeleted(user);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const formDelete = async (event: FormEvent) => {
    event.preventDefault();
    await deleteUser();
  };
  return (
    <Fragment>
      <button
        title="Slet bruger"
        className="blank-button sm"
        onClick={() => setShown(true)}
      >
        <FontAwesomeIcon icon={faTrash} />
      </button>

      <Modal show={shown} onHide={() => setShown(true)}>
        <form onSubmit={formDelete}>
          <Modal.Title>Slet bruger</Modal.Title>
          <Modal.Body>
            <Form.Group>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>Email</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl readOnly={true} defaultValue={user.email} />
              </InputGroup>
            </Form.Group>
            <Form.Group>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>Fornavn</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl readOnly={true} defaultValue={user.firstName} />
              </InputGroup>
            </Form.Group>
            <Form.Group>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>Efternavn</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl readOnly={true} defaultValue={user.lastName} />
              </InputGroup>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="warning" disabled={loading} type="submit">
              Slet {loading && <Spinner animation="border" size="sm" />}
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                setShown(false);
              }}
            >
              Luk
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </Fragment>
  );
};

export default DeleteUser;
